var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5892_172516",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5892_172516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 14.166H10.8307V9.16602H9.16406V14.166ZM9.9974 7.49935C10.2335 7.49935 10.4314 7.41949 10.5911 7.25977C10.7509 7.10004 10.8307 6.90213 10.8307 6.66602C10.8307 6.4299 10.7509 6.23199 10.5911 6.07227C10.4314 5.91254 10.2335 5.83268 9.9974 5.83268C9.76128 5.83268 9.56337 5.91254 9.40365 6.07227C9.24392 6.23199 9.16406 6.4299 9.16406 6.66602C9.16406 6.90213 9.24392 7.10004 9.40365 7.25977C9.56337 7.41949 9.76128 7.49935 9.9974 7.49935ZM9.9974 18.3327C8.84462 18.3327 7.76128 18.1139 6.7474 17.6764C5.73351 17.2389 4.85156 16.6452 4.10156 15.8952C3.35156 15.1452 2.75781 14.2632 2.32031 13.2493C1.88281 12.2355 1.66406 11.1521 1.66406 9.99935C1.66406 8.84657 1.88281 7.76324 2.32031 6.74935C2.75781 5.73546 3.35156 4.85352 4.10156 4.10352C4.85156 3.35352 5.73351 2.75977 6.7474 2.32227C7.76128 1.88477 8.84462 1.66602 9.9974 1.66602C11.1502 1.66602 12.2335 1.88477 13.2474 2.32227C14.2613 2.75977 15.1432 3.35352 15.8932 4.10352C16.6432 4.85352 17.237 5.73546 17.6745 6.74935C18.112 7.76324 18.3307 8.84657 18.3307 9.99935C18.3307 11.1521 18.112 12.2355 17.6745 13.2493C17.237 14.2632 16.6432 15.1452 15.8932 15.8952C15.1432 16.6452 14.2613 17.2389 13.2474 17.6764C12.2335 18.1139 11.1502 18.3327 9.9974 18.3327ZM9.9974 16.666C11.8585 16.666 13.4349 16.0202 14.7266 14.7285C16.0182 13.4368 16.6641 11.8605 16.6641 9.99935C16.6641 8.13824 16.0182 6.56185 14.7266 5.27018C13.4349 3.97852 11.8585 3.33268 9.9974 3.33268C8.13628 3.33268 6.5599 3.97852 5.26823 5.27018C3.97656 6.56185 3.33073 8.13824 3.33073 9.99935C3.33073 11.8605 3.97656 13.4368 5.26823 14.7285C6.5599 16.0202 8.13628 16.666 9.9974 16.666Z",
    fill: "#4F9E88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/info-outlined.2e361d891718af21dd9295a2b1cdd622.svg";
export { ForwardRef as ReactComponent };